export default {
    operacion: "list",
    tupa: {
        
        "estado": false
    }

}